var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99967 1.33301C4.31301 1.33301 1.33301 4.31301 1.33301 7.99967C1.33301 11.6863 4.31301 14.6663 7.99967 14.6663C11.6863 14.6663 14.6663 11.6863 14.6663 7.99967C14.6663 4.31301 11.6863 1.33301 7.99967 1.33301ZM7.99967 13.333C5.05967 13.333 2.66634 10.9397 2.66634 7.99967C2.66634 5.05967 5.05967 2.66634 7.99967 2.66634C10.9397 2.66634 13.333 5.05967 13.333 7.99967C13.333 10.9397 10.9397 13.333 7.99967 13.333ZM10.393 4.66634L7.99967 7.05967L5.60634 4.66634L4.66634 5.60634L7.05967 7.99967L4.66634 10.393L5.60634 11.333L7.99967 8.93967L10.393 11.333L11.333 10.393L8.93967 7.99967L11.333 5.60634L10.393 4.66634Z",
    fill: "#D74942"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.9277562aef4aa45541bb41304362adc8.svg";
export { ForwardRef as ReactComponent };